import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from '../../../components/Loader';

// Component
import AdminReviewsManagement from '../../../components/siteadmin/AdminReviewsManagement/AdminReviewsManagement';

// Query
import adminReviewsQuery from './adminReviewsQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './AdminReviews.css';

class AdminReviews extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getAdminReviews: PropTypes.array,
        })
    };

    static defaultProps = {
        data: {
            loading: true
        }
    };

    render() {

        const { reviewsManagement: { loading, reviewsManagement } } = this.props;

        if (loading) {
            return <Loader type={"text"} />;
        } else {
            return (
                <AdminReviewsManagement
                    reviewsManagement={reviewsManagement}
                />
            );
        }
    }
}

export default compose(
    withStyles(s),
    withQuery(adminReviewsQuery, {
        name: 'reviewsManagement',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(AdminReviews);